import React from 'react';
import { graphql } from 'gatsby';
import { Breadcrumb } from '../components/2.0version/breadcrumb/Breadcrumb';
import { ListingAgenda } from '../components/2.0version/listingAgenda/ListingAgenda';
import { SanityFilters } from '../utils/types';
import { URLS } from '../../constants';
import * as styles from './agenda.module.scss';
import { HeroHeaderImage } from '../components/2.0version/heroHeaderImage/HeroHeaderImage';
import { RoundCorners } from '../components/2.0version/roundCorners/RoundCorners';
import { SEO } from '../components/2.0version/seo/Seo';
import { initMinMaxCriterias } from '../utils/initMinMaxCriterias';
import { AgendaQuery } from 'graphql-types';

interface IAgendaProps {
  data?: AgendaQuery;
}

const Agenda = ({ data }: IAgendaProps) => {
  const sanityAgendaPage = data?.sanityAgendaPage;

  const sanityFilters = sanityAgendaPage?.filters;
  const minMaxCriterias = initMinMaxCriterias(data?.allIngenieOt?.nodes ?? []);

  return (
    <div className={styles.wrapper}>
      <SEO rawMeta={sanityAgendaPage?._rawMetadata} />
      <HeroHeaderImage
        image={sanityAgendaPage?.imageHeader?.image?.asset?.gatsbyImageData}
        alt={sanityAgendaPage?.imageHeader?.alt}
        title={sanityAgendaPage?.pageHeader?._rawTitle}
        description={sanityAgendaPage?.pageHeader?._rawDescription.text}
      />
      <RoundCorners>
        <Breadcrumb
          pathsInput={[{ label: sanityAgendaPage?._rawPageHeader?.title, url: URLS.blog.url }]}
        />
      </RoundCorners>

      <ListingAgenda
        sanityFilters={sanityFilters as SanityFilters}
        ots={data?.allIngenieOt.nodes}
        minMaxCriterias={minMaxCriterias}
      />
    </div>
  );
};

export const QUERY = graphql`
  query Agenda {
    allIngenieOt(filter: { agenda: { eq: true } }) {
      nodes {
        agenda
        ...cardOtFragment
        ...wishListFragment
        pictosPartners {
          url
          alt
        }
        criteres210 {
          histoirePatrimoine
          art
          musique
          gastronomieEtVins
          sport
          nature
          soiree
          jeunePublic
          plusDeRdv
        }
        ouvertures {
          date_debut
          date_fin
        }
        localisation {
          adresse {
            ville
          }
        }
      }
    }
    sanityAgendaPage {
      _rawMetadata
      id
      _rawPageHeader
      pageHeader {
        _rawTitle
        _rawDescription
      }
      imageHeader {
        alt
        image {
          asset {
            gatsbyImageData
          }
        }
      }
      filters {
        label
        filters {
          ... on SanityCriterias {
            id
            criteria
            _rawLabel
            type
          }
        }
        id
      }
    }
  }
`;

export default Agenda;
